import { Glyph } from "./../staff/glyphs";

const LINE_GAP = 10;
const ICON_SIZE = LINE_GAP * 4;

function paletteTransformFor(symbol) {
  if (symbol === "eighth_pair") return "translate(-16, 15.5)";
  if (symbol === "whole_note") return "translate(-8, 15.5)";
  if (symbol.endsWith("_note")) return "translate(-7, 15.5)";
  if (symbol === "whole_rest") return "translate(-7, 0)";
  if (symbol === "half_rest") return "translate(-7, 5)";
  return "translate(-3, 2)";
}

function RestAnchor({ symbol }) {
  if (symbol === "half_rest" || symbol === "whole_rest") {
    return (
      <line
        x1={-6}
        x2={19}
        y1={0}
        y2={0}
        stroke="#000"
        strokeWidth={1.2}
      />
    );
  }
  return null;
}

export default function GlyphChoiceButton({
  symbol,
  selected,
  correct = false,
  wrong = false,
  onClick,
  disabled = false
}) {
  let border = "1px solid #ccc";

  if (correct) border = "3px solid #2e7d32"; // green
  else if (wrong) border = "3px solid #c62828"; // red
  else if (selected) border = "3px solid black";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={symbol.replaceAll("_", " ")}
      style={{
        width: ICON_SIZE + 12,
        height: ICON_SIZE + 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "white",
        border,
        borderRadius: 6,
        cursor: disabled ? "default" : "pointer",
        padding: 0
      }}
    >
      <svg
        width={ICON_SIZE}
        height={ICON_SIZE}
        viewBox="-24 -24 48 48"
      >
        <g transform={paletteTransformFor(symbol)}>
          {symbol.endsWith("_rest") && <RestAnchor symbol={symbol} />}
          <Glyph symbol={symbol} />
        </g>
      </svg>
    </button>
  );
}
